import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalsService } from 'app/services/globals.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';
import { OmsService } from 'app/services/oms.service';
import { OrdersService } from 'app/services/orders.service';
import { UsersService } from 'app/services/users.service';
import { Subject, of } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { Location } from '@angular/common'

import { CustomerService } from '../../services/customer.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-order-upload',
	templateUrl: './order-upload.component.html',
	styleUrls: ['./order-upload.component.scss']
})
export class OrderUploadComponent {

	// @ViewChild('itemdetails') itemDetails: ElementRef;
	// @ViewChild('purchasedetails') purchasedetails: ElementRef;
	// @ViewChild('creditover') creditover: ElementRef;
	// @ViewChild('configproductele') configproductele: ElementRef;
	// @ViewChild('itemHistoryRef') itemHistoryRef: ElementRef;
	// @ViewChild('nonstock') nonstockref: ElementRef;
	// @ViewChild('uploadorder') uploadorderref: ElementRef;
	// @ViewChild('fileInput') fileInput: ElementRef;


	CHAT_ROOM = 'OrderBoard';
	orderResults: any = [];
	customer_data: any = [];
	filters: any = [];
	debtorno: any = '';
	branchcode: any = '';

	poHelp = false;
	uploadedHeaders: string[] = [];
	uploadedRawData: any[] = [];
	columnMappings: any = {};
	availableFieldTypes: string[] = ['stockid', 'qty_purchase', 'price', 'ignore'];
	requiredMappings: any = { 'stockid': false, 'qty_purchase': false, 'price': false };
	hasDuplicateMappings = false;
	hasRequiredMappings: any = false;
	fileSpecificHeaders: { [fileName: string]: string[] } = {};
	fileSpecificMappings: { [fileName: string]: { [header: string]: string } } = {};
	selectedFile = 'all';
	availableFiles: string[] = [];
	files: File[] = [];
	orderUploadColumns: string[] = ['stockid', 'description', 'quantity', 'price'];
	uploaddata: any = false;
	processing_recs = false;
	orderDataSource: any = false;
	orderReviewReady = false;
	upload_error: any = false;
	fieldMatch = true;
	today = new Date();
	lastsearch: any = '';
	//cart
	dspcost = true;
	showGuide = false;
	total_cart_qty = 0;
	cart_items: any = [];
	cart_totals: any = [];
	selectedindex = 0;
	activeLink: any = 'order_entry';

	//subscription to search
	inventorysearching: any = false;

	search_items: any = [];
	filtered_items: any = [];
	searching = false;

	taxgroups: any = [];
	salespeople: any = [];
	shipvia: any = [];
	terms: any = [];
	zones: any = [];
	locations: any = [];
	holdreasons: any = [];
	itemhistory: any = [];


	addingitems = false;
	customerinfo = true;
	//viewing item
	item_details: any = false;
	editing_order = false;
	order_details: any = [];
	purchase_items: any = [];
	user: any = [];

	showfilters = false;
	overcredit = false;
	allowed_credit = false;
	proceed = false;
	overcredit_override = '';
	selecteditem: any = false;
	config: any = [];

	nonStockForm: UntypedFormGroup;
	brands: any = [];
	librarysearch = new UntypedFormControl('');
	librarySearchResults: any = [];
	librarySearchSelected: any = false;
	librarySearching: any = false;
	collapseMini: any = false;
	customerdatafortrans: any = false;

	resetTrans: Subject<boolean> = new Subject<boolean>();
	dupedSuppliedHeaders: any = false;
	suppliedHeaders: any = false;
	lookupType = false;
	mappingsFulfilled: any = { status: false, missing:[] };

	@Input() customerdata: any = null;
	@Output() uploaded = new EventEmitter<any>();


	constructor(private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService) {

		this.config = this.globalsService.getApiConfig();
	}


	ngOnInit(): void {

		this.globalSearchService.mesagesallowed.next(false);
		
		// Check if customer data is provided as input
		if (this.customerdata) {
			this.customer_data = this.customerdata;
			this.debtorno = this.customerdata.customer.debtorno;
			this.branchcode = this.customerdata.customer.branchcode;
			this.customer_data.dissallowinvoices = false;
			// Load additional data for the provided customer
			this.loadCustomerData();
		} else {
			// Fallback to route parameters if no customer data provided
			this.customer_data.dissallowinvoices = false;

			this.route.params
				.pipe(
					// Only proceed if the debtor number or branch code has changed
					filter(params => this.debtorno !== params['cid'] || this.branchcode !== params['branch']),
					tap(params => {
						// Update local variables
						this.debtorno = params['cid'];
						this.branchcode = params['branch'];
					}),
					// Use switchMap to flatten the inner subscription
					switchMap(params =>
						this.orderService.getCustomer(this.debtorno, this.branchcode).pipe(
							catchError(err => {
								//'Failed to load customer data:', err);
								return of(null); // Handle the error gracefully
							})
						)
					),
					filter(results => !!results), // Proceed only if customer data is successfully loaded
					tap(results => {
						this.customer_data = results;
					}),
					// Fetch additional details related to the debtor and branch
					switchMap(results =>
						this.customerService.getDebtorWithBranch(results.debtorno, results.branchcode).pipe(
							catchError(err => {
							//'Failed to load debtor details:', err);
								return of(null); // Handle the error gracefully
							})
						)
					)
				)
				.subscribe((customerDetails: any) => {
					if (customerDetails) {
						this.customerdatafortrans = customerDetails;
					} else {
					//'No customer details were found.');
					}
				});
		}
	}

	loadCustomerData() {
		// Load additional customer data when customerdata is provided as input
		this.customerService.getDebtorWithBranch(this.debtorno, this.branchcode)
			.pipe(
				catchError(err => {
					//'Failed to load debtor details:', err);
					return of(null);
				})
			)
			.subscribe((customerDetails: any) => {
				if (customerDetails) {
					this.customerdatafortrans = customerDetails;
				} else {
					//'No customer details were found.');
				}
			});
	}


	onFileInputChange(event: Event) {
		const input = event.target as HTMLInputElement;
		if (input.files) {

			for (let i = 0; i < input.files.length; i++) {
				this.files.push(input.files[i]);
			}
			// Reset the file input so the same file can be selected again if needed
			input.value = '';
		}
	}

	// Add method to clear all files
	clearAllFiles() {
		this.files = [];
		this.upload_error = false;
	}


	initializeColumnMappings() {
		// this.hasDuplicateMappings = this.checkForDuplicateMappings();
		this.columnMappings = {};
		this.availableFiles.forEach(fileName => {
			if (!this.fileSpecificMappings[fileName]) {
				this.fileSpecificMappings[fileName] = {};

				if (!this.fileSpecificHeaders[fileName] || this.fileSpecificHeaders[fileName].length === 0) {
					const fileRows = this.uploadedRawData.filter(row => row._sourceFile === fileName);
					if (fileRows.length > 0) {
						const headerKeys = Object.keys(fileRows[0]).filter(key => key !== '_sourceFile');
						this.fileSpecificHeaders[fileName] = headerKeys;
					}
				}

				this.fileSpecificHeaders[fileName].forEach(header => {
					if (header.toLowerCase().includes('stock') || header.toLowerCase().includes('sku')) {
						this.fileSpecificMappings[fileName][header] = 'stockid';
					} else if (header.toLowerCase().includes('qty') || header.toLowerCase().includes('quantity')) {
						this.fileSpecificMappings[fileName][header] = 'qty_purchase';
					} else if (header.toLowerCase().includes('price') || header.toLowerCase().includes('cost')) {
						this.fileSpecificMappings[fileName][header] = 'price';
					}else if ((header.toLowerCase().includes('brand') || header.toLowerCase().includes('mfg')) && this.lookupType){
						this.fileSpecificMappings[fileName][header] = 'brand';
					} else {
						this.fileSpecificMappings[fileName][header] = 'ignore';
					}
				});
			}
		});

		this.uploadedHeaders = [];
		this.availableFiles.forEach(fileName => {
			if (this.fileSpecificHeaders[fileName]) {
				this.uploadedHeaders = [...new Set([...this.uploadedHeaders, ...this.fileSpecificHeaders[fileName]])];
			}
		});

		this.uploadedHeaders.forEach(header => {
			let mappingType = '';
			let consistent = true;

			for (const fileName of this.availableFiles) {
				if (this.fileSpecificHeaders[fileName] && this.fileSpecificHeaders[fileName].includes(header)) {
					const fileMapping = this.fileSpecificMappings[fileName][header];
					if (mappingType === '') {
						mappingType = fileMapping;
					} else if (mappingType !== fileMapping) {
						consistent = false;
						break;
					}
				}
			}

			this.columnMappings[header] = consistent ? mappingType : 'ignore';
		});
		this.hasDuplicateMappings = this.checkForDuplicateMappings();
	}

	updateColumnMapping(originalHeader: string, newMapping: string, fileName: string = null) {
		this.hasDuplicateMappings = this.checkForDuplicateMappings();
		if (fileName) {
			this.fileSpecificMappings[fileName][originalHeader] = newMapping;
		} else {
			this.columnMappings[originalHeader] = newMapping;

			if (this.selectedFile === 'all') {
				this.availableFiles.forEach(file => {
					if (this.fileSpecificHeaders[file].includes(originalHeader)) {
						this.fileSpecificMappings[file][originalHeader] = newMapping;
					}
				});
			}
		}


		this.hasDuplicateMappings = this.checkForDuplicateMappings();
	}

	checkForRequiredFields(){

		let headers;
		if(this.selectedFile !== 'all'){
			headers = this.fileSpecificMappings[this.selectedFile];
		}else{
			headers = this.columnMappings;
		}

		//reset req maps to false
		const req_maps = Object.keys(this.requiredMappings);
		Object.keys(this.requiredMappings).forEach((k) => {
			this.requiredMappings[k] = false;
		})

		//update req maps based on mapped column values
		Object.values(headers).forEach((mappedname: any) => {
			if(req_maps.includes(mappedname)){
				this.requiredMappings[mappedname] = true;
			}
		});

		//return if all are supplied or if any are false
		let value = true;
		Object.values(this.requiredMappings).forEach((mapped) => {
			if(!mapped){
				value = false;
			}
		})

		return value;
	}

	checkForDuplicateMappings(): boolean {
		const fileName = this.selectedFile;
		this.dupedSuppliedHeaders = {};
		this.suppliedHeaders = {};
		const foundMaps = [];
		// For single file view
		if (fileName !== 'all') {
			if (!this.fileSpecificMappings[fileName]) {
				return false;
			}

			// Simple implementation for direct check
			const fieldTypes = {};
			for (const header in this.fileSpecificMappings[fileName]) {
				const fieldType = this.fileSpecificMappings[fileName][header];

				if (fieldType !== 'ignore') {
					foundMaps.push(fieldType);
					this.suppliedHeaders[fieldType] = true;
					if (fieldTypes[fieldType]) {
						this.dupedSuppliedHeaders[fieldType] = true;
						return true; // Duplicate found
					}
					fieldTypes[fieldType] = true;
				}
			}
			return false;
		}

		// For "all files" view, check each file
		for (const file of this.availableFiles) {
			if (!this.fileSpecificMappings[file]) {
				continue;
			}

			const fieldTypes = {};

			for (const header in this.fileSpecificMappings[file]) {
				const fieldType = this.fileSpecificMappings[file][header];

				if (fieldType !== 'ignore') {
					foundMaps.push(fieldType);
					this.suppliedHeaders[fieldType] = true;

					if (fieldTypes[fieldType]) {
						this.dupedSuppliedHeaders[fieldType] = true;
						return true; // Duplicate found
					}
					fieldTypes[fieldType] = true;
				}
			}
		}


		return false;
	}

	applyColumnMappings() {
		const processedData = [];
		this.hasDuplicateMappings = this.checkForDuplicateMappings();
		this.uploadedRawData.forEach(row => {
			const processedRow: any = {
				_sourceFile: row._sourceFile
			};
			const fileName = row._sourceFile;

			if (fileName && this.fileSpecificMappings[fileName]) {
				Object.keys(row).forEach(originalHeader => {
					if (originalHeader === '_sourceFile') {return;}
					const mappedField = this.fileSpecificMappings[fileName][originalHeader];
					if (mappedField && mappedField !== 'ignore') {
						processedRow[mappedField] = row[originalHeader];
					}
				});
			} else {
				Object.keys(row).forEach(originalHeader => {
					if (originalHeader === '_sourceFile') {return;}

					const mappedField = this.columnMappings[originalHeader];
					if (mappedField && mappedField !== 'ignore') {
						processedRow[mappedField] = row[originalHeader];
					}
				});
			}
			if (processedRow['stockid'] || processedRow['qty_purchase']) {
				if (!processedRow['stockid']) {processedRow['stockid'] = '';}
				if (!processedRow['qty_purchase']) {processedRow['qty_purchase'] = 1;}
				if (!processedRow['price']) {processedRow['price'] = 0;}

				processedData.push(processedRow);
			}
		});
		return processedData;
	}

	uploadOrder() {
		this.resetUploadOrder();
		this.uploaddata = {
			items: [],
			lines: { good: 0, bad: 0 }
		};

		this.upload_error = false;
		this.uploadedRawData = [];
		this.uploadedHeaders = [];
		this.fileSpecificHeaders = {};
		this.fileSpecificMappings = {};
		this.availableFiles = [];

		let files_to_process = this.files.length;
		let allFileData = [];

		for (let i = 0; i < this.files.length; i++) {
			const name = this.files[i].name;
			const type = this.files[i].type;

			if (!this.availableFiles.includes(name)) {
				this.availableFiles.push(name);
			}

			this.readFile(this.files[i]).then(fileContents => {
				const upload = {
					content: fileContents,
					name: name,
					mime: type,
          			origin: 'so'
				}
				this.orderService.uploadOrder(upload).subscribe((results: any) => {
					if (results['error']) {
						(!this.upload_error) ? this.upload_error = [] : '';
						this.upload_error = [results['error'], ...this.upload_error];
					} else {
						const currentFileData = results.rows;
						const dataWithFileSource = currentFileData.map(row => ({
							...row,
							_sourceFile: name
						}));

						allFileData = [...allFileData, ...dataWithFileSource];
						if (currentFileData && currentFileData.length > 0) {
							const firstRow = currentFileData[0];
							const currentHeaders = Object.keys(firstRow);

							this.fileSpecificHeaders[name] = [...currentHeaders];
							this.uploadedHeaders = [...new Set([...this.uploadedHeaders, ...currentHeaders])];
						}

						this.processing_recs = true;
						currentFileData.forEach((row) => {
							if (row.qty_purchase && parseFloat(row.qty_purchase) != 0) {
								this.uploaddata['items'].push({
									stockid: row.stockid || '',
									quantity: row.qty_purchase || 1,
									price: row.price || 0,
									description: row.description || '',
									discount: 0,
									_sourceFile: name
								});
							}
						});
					}

					if (--files_to_process == 0) {
						this.uploadedRawData = allFileData;
						this.uploadedRawData = this.uploadedRawData.filter((i) => { return i.stockid !== '' && i.price !== '' });
						this.selectedFile = 'all';
						this.initializeColumnMappings();

						if (this.upload_error && this.upload_error.length) {
							this.resetUploadOrder();
							return;
						}

						if (this.uploaddata['items'] && this.uploaddata['items'].length > 0) {
							const data = {
								items: this.uploaddata['items'],
								debtorno: this.debtorno,
								branchcode: this.branchcode
							}

							this.orderService.buildOrderFromUpload(data).subscribe((res) => {
								this.orderDataSource = {};

								if (res['good']) {
									this.orderDataSource['good'] = new MatTableDataSource(res['good']);
									res['good'].map((i) => {
										this.uploaddata['lines']['good']++;
									});
									this.uploaddata['items'] = res['good'];
								}

								if (res['bad']) {
									this.orderDataSource['bad'] = new MatTableDataSource(res['bad']);
									res['bad'].map((i) => {
										this.uploaddata['lines']['bad']++;
									});
								}

								this.orderReviewReady = true;
								this.processing_recs = false;
							});
						} else {
							this.orderReviewReady = true;
							this.processing_recs = false;
						}
					}
				});
			});
		}
	}

	applyMappingsAndProcessOrder() {

		const processedData = this.applyColumnMappings();
		const hasDuplicates = this.checkForDuplicateMappings();

		// Reset previous data
		this.uploaddata = {
			items: [],
			lines: { good: 0, bad: 0 }
		};

		processedData.forEach(row => {
			if (parseFloat(row.qty_purchase) != 0) {
				this.uploaddata['items'].push({
					stockid: row.stockid,
					quantity: row.qty_purchase,
					price: row.price || 0,
					description: row.description || '',
					discount: 0,
					mapped: 1,
					brand: row.brand,
					_sourceFile: row._sourceFile || ''
				});
			}
		});

		const data = {
			items: this.uploaddata['items'],
			debtorno: this.debtorno,
			branchcode: this.branchcode,
			mfgparts: this.lookupType
		}

		this.processing_recs = true;

		this.orderService.buildOrderFromUpload(data).subscribe((res) => {
			this.orderDataSource = {};

			if (res['good']) {
				this.orderDataSource['good'] = new MatTableDataSource(res['good']);
				res['good'].map((i) => {
					this.uploaddata['lines']['good']++;
				});
				this.uploaddata['items'] = res['good'];
			}

			if (res['bad']) {
				this.orderDataSource['bad'] = new MatTableDataSource(res['bad']);
				res['bad'].map((i) => {
					this.uploaddata['lines']['bad']++;
				});
			}

			this.processing_recs = false;
		});
	}

	addOrderItems() {

		if (this.uploaddata['items'] && this.uploaddata['items'].length > 0) {
			this.orderService.addBatchItemsToCart(this.uploaddata['items'], this.debtorno, this.branchcode, 'batch').subscribe((results: any) => {
				this.cart_items = results;
				this.globalSearchService.showNotification('Items added to cart', 'success', 'bottom', 'left');
				this.resetUploadOrder();
				this.modalService.dismissAll();
				// Switch to the Order tab
				this.uploaded.emit();

			});
		}
	}

	hasNededMaps(){
		//avail
		this.availableFieldTypes
	}

	resetUploadOrder() {
		this.orderReviewReady = false;
		this.processing_recs = false;
		this.orderDataSource = false;
		this.uploadedRawData = [];
		this.uploadedHeaders = [];
		this.columnMappings = {};
		this.fileSpecificHeaders = {};
		this.fileSpecificMappings = {};
		this.availableFiles = [];
		this.selectedFile = 'all';
	}

	toggleUploadHelp() {
		this.poHelp = this.poHelp == true ? false : true;
	}

	onSelect(event) {
		if (event && event.addedFiles) {
			this.files.push(...event.addedFiles);
		} else {
			console.error('Invalid event format in onSelect:', event);
		}
	}

	onRemove(event) {
		const index = this.files.indexOf(event);
		if (index !== -1) {
			this.files.splice(index, 1);
		} else {
			console.error('Failed to find file in the files array:', event);
		}
		this.upload_error = false;
	}

	private async readFile(file: File): Promise<string | ArrayBuffer> {
		return new Promise<string | ArrayBuffer>((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});

		this.files = [];
	}

	handleOrderUpload(event: any) {
		if (event && event.success) {
			if (event.orderno) {
				this.globalSearchService.showNotification('Order successfully uploaded', 'success', 'bottom', 'left');
				this.router.navigate(['/orders/invoice/' + event.orderno]);
			} else {
				this.orderService.getCart(this.debtorno, this.branchcode).subscribe((items: any) => {
					this.cart_items = items;
					// this.updateTotals();
					// this.sendCartUpdate();
					this.uploaded.emit()
					this.globalSearchService.showNotification('Items added to cart', 'success', 'bottom', 'left');
				});
			}
		} else if (event && event.error) {
			this.globalSearchService.showNotification('Upload failed: ' + event.message, 'danger', 'bottom', 'left');
		}
	}


	changeLookup(){
		console.log('yashdad');
		this.lookupType = !this.lookupType;
		if(this.lookupType){
			this.availableFieldTypes =  ['stockid', 'qty_purchase', 'price', 'brand', 'ignore'];
			this.requiredMappings = { 'stockid':false, 'qty_purchase':false, 'price':false, 'brand':false };
		}else{
			this.availableFieldTypes =  ['stockid', 'qty_purchase', 'price', 'ignore'];
			this.requiredMappings = { 'stockid':false, 'qty_purchase': false, 'price': false };
		}
		this.checkForDuplicateMappings();
	}


}
